module.exports = __webpack_public_path__ + "static/media/piscina.bd79b84c.png";